export const DIRECTOR_NAME = "Denise French";
export const DIRECTOR_EMAIL = "director@palmettoha.org";

export const OFFICE_PHONE = "8033272344";

export const TRANSCRIPTS_EMAIL = "transcripts@palmettoha.org";
export const TRANSCRIPTS_NAME = "Tara Bruce";

export const NOTIFICATIONS_NAME = "PHA Notifications";
export const NOTIFICATIONS_EMAIL = "phanotifications@palmettohomeschool.org";

export const SUPPORT_EMAIL = "support@palmettohomeschool.org";

export const MEMBER_DOC_LINK =
  "https://www.dropbox.com/sh/wzp8wpn6ehzgykc/AAAVWD5De4sSj4j8a3H9kjJla?dl=0";

export const OFFICE_ADDR_STREET = "1030 Riverwalk Parkway, Ste 205";
export const OFFICE_ADDR_CITYSTATE = "Rock Hill, SC 29730";

export const SC59_65_47_AFFIRMATION =
  "I/we affirm that I/we meet the homeschool requirement as parent or legal guardian of enrolled student(s) as per SC law (Section 59-65-47).";
export const SINGLE_PARENT_AFFIRMATION =
  "I affirm that I am the only biological or adoptive parent living in the home and that there is no court order mandating educational decisions be made jointly by myself and the other biological/adoptive parent.";
